<template>
    <div>
        <v-text-field v-model="value" :label="placeholder" append-icon="mdi-calendar" :readonly="readOnly"
            v-bind="settings" v-on="$on" outlined dense v-if="readOnly" :key="refreshDate"
            :class="error ? 'show-errors' : 'hide-error'" :error-messages="error" />

        <v-dialog v-else ref="dialog" v-model.lazy="abrirDateModal" persistent @blur="updateValue" width="600px">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model.lazy="formatedDateRange" :label="placeholder" append-icon="mdi-calendar"
                    :readonly="readOnly" v-bind="attrs" v-on="on" outlined dense
                    :class="error ? 'show-errors' : 'hide-error'" :error-messages="error"
                    :disabled="disabled"></v-text-field>
            </template>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="text-center mb-2">
                                <strong>Data Início</strong>
                            </div>
                            <v-date-picker v-model="dataInicio" scrollable locale="pt-br" first-day-of-week="1"
                                show-week :min="minimumDate" :max="dataFim" full-width></v-date-picker>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="text-center mb-2">
                                <strong>Data Fim</strong>
                            </div>
                            <v-date-picker v-model="dataFim" scrollable locale="pt-br" first-day-of-week="1" show-week
                                :min="dataInicio || minimumDate" full-width></v-date-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="abrirDateModal = false">
                        Fechar
                    </v-btn>
                    <v-btn text color="primary" @click="salvarRange">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    name: "SGPFormDataRangeComponent",

    props: {
        placeholder: {
            type: String,
            required: false,
            default: "Período"
        },

        name: {
            type: String,
            required: true,
        },

        value: {
            type: [Object, String],
            required: false,
            default: () => ({ inicio: null, fim: null })
        },

        readOnly: {
            type: Boolean,
            required: false,
            default: false
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

        error: {
            type: Boolean,
            required: false,
            default: false
        },

        minimumDate: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            abrirDateModal: false,
            dataInicio: null,
            dataFim: null,
            formatedDateRange: '',
            refreshDate: true
        }
    },

    mounted() {
        this.parseValueInit()
    },

    computed: {
        settings() {
            return {
                ...this.$attrs
            }
        }
    },

    methods: {
        parseValueInit() {
            if (!this.value || (typeof this.value === 'string' && !this.value.trim())) {
                this.dataInicio = null
                this.dataFim = null
                this.formatedDateRange = ''
                return
            }

            let inicio = null
            let fim = null

            if (typeof this.value === 'object' && this.value !== null) {
                inicio = this.value.inicio || this.value.data_inicio || null
                fim = this.value.fim || this.value.data_fim || null
            } else if (typeof this.value === 'string') {
                const parts = this.value.split(',')
                if (parts.length === 2) {
                    inicio = parts[0].trim()
                    fim = parts[1].trim()
                }
            }

            this.dataInicio = inicio ? this.formatToDatePicker(inicio) : null
            this.dataFim = fim ? this.formatToDatePicker(fim) : null
            this.updateFormattedRange()
        },

        formatToDatePicker(dateString) {
            if (!dateString) return null

            if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
                return dateString.split(' ')[0]
            }

            const m = moment(dateString, ['YYYY-MM-DD', 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm'])
            return m.isValid() ? m.format('YYYY-MM-DD') : null
        },

        updateFormattedRange() {
            if (this.dataInicio && this.dataFim) {
                const inicio = moment(this.dataInicio).format('DD/MM/YYYY')
                const fim = moment(this.dataFim).format('DD/MM/YYYY')
                this.formatedDateRange = `${inicio} - ${fim}`
            } else if (this.dataInicio) {
                this.formatedDateRange = moment(this.dataInicio).format('DD/MM/YYYY')
            } else {
                this.formatedDateRange = ''
            }
        },

        salvarRange() {
            const rangeValue = {
                inicio: this.dataInicio ? moment(this.dataInicio).format('YYYY-MM-DD') : null,
                fim: this.dataFim ? moment(this.dataFim).format('YYYY-MM-DD') : null
            }

            this.updateFormattedRange()
            this.$emit('input', rangeValue)
            this.$emit('change', rangeValue)
            this.abrirDateModal = false
        },

        updateValue() {
            if (!this.abrirDateModal) {
                this.salvarRange()
            }
        }
    },

    watch: {
        abrirDateModal(val) {
            if (!val) {
                this.updateValue()
            }
        },

        value(val) {
            if (!val || (typeof val === 'string' && !val.trim())) {
                this.dataInicio = null
                this.dataFim = null
                this.formatedDateRange = ''
                this.refreshDate = false
            } else {
                this.parseValueInit()
                this.refreshDate = true
            }
        },

        dataInicio() {
            this.updateFormattedRange()
        },

        dataFim() {
            this.updateFormattedRange()
        }
    }

}
</script>

<style scoped>
.hide-error.v-text-field__details {
    display: none !important;
}
</style>
